function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.9999 0.333328C5.55992 0.333328 0.333252 5.56 0.333252 12C0.333252 18.44 5.55992 23.6667 11.9999 23.6667C18.4399 23.6667 23.6666 18.44 23.6666 12C23.6666 5.56 18.4399 0.333328 11.9999 0.333328ZM11.9999 13.1667C11.3583 13.1667 10.8333 12.6417 10.8333 12V7.33333C10.8333 6.69166 11.3583 6.16666 11.9999 6.16666C12.6416 6.16666 13.1666 6.69166 13.1666 7.33333V12C13.1666 12.6417 12.6416 13.1667 11.9999 13.1667ZM13.1666 17.8333H10.8333V15.5H13.1666V17.8333Z",
  fill: "#FFA401"
});

var SvgIconWarning = function SvgIconWarning(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-warning.99db2d8a.svg";
export { ForwardRef as ReactComponent };